import { styled } from '@mui/material';
import { grey } from '@mui/material/colors';
import { Chip, ChipProps } from 'shared/mui/Chips';

type Size = 'm' | 'l';

type ColorIconProps = {
  color: string;
  size: Size;
};

const sizeConfig: Record<Size, string> = {
  m: '16px',
  l: '18px',
};

export const ColorIcon = styled('div')<ColorIconProps>(({ color, size }) => ({
  backgroundColor: color,
  borderRadius: '100%',
  width: sizeConfig[size],
  height: sizeConfig[size],
}));

type Props = {
  iconColor?: string;
  iconSize?: Size;
} & ChipProps;

export const ColorChip = ({ iconColor, iconSize = 'm', ...rest }: Props) => {
  return <Chip icon={<ColorIcon color={iconColor || grey[500]} size={iconSize} />} {...rest} />;
};
